import React, { Component } from 'react'
import Button from "../../../components/Button"
import Layout from "../../../components/Layout"
import "./res.css"



class ResetPassword extends Component {
    render() {
        return (
            <Layout {...this.props}>
                <div className="field">
                    <div className="signinField">
                    <div className="signIn">
                        <div className="signHead">
                            <h1>RESET PASSWORD</h1>
                        </div>
                            <div className="signInForm">
                                <form>
                                    <div className="formGrid">
                                        <div className="form-field">
                                            <input placeholder="New Password" className="formIn" />
                                        </div>
                                        <p className="passtext">Password must contain numbers or symbols</p>
                                        <div className="form-field">
                                            <input placeholder="Confirm Password" className="formIn"/>
                                        </div>
                                    </div>
                                    <div className="formFlex topAcc">
                                        <Button className="signin-submit">Reset</Button>
                                    </div>
                                </form>
                            </div>
                    </div>
                    </div>
                </div>
            </Layout>
        )
    }
}

export default ResetPassword;